<ng-container *transloco="let t">
	<div class="registration-page-container">
		<p class="title is-4 mb-2">{{ t('content.steps.alreadyRegistered') }}</p>

		<div class="content">
			<p [innerHTML]="t('content.pages.alreadyRegistered.instructions')"></p>
		</div>
	</div>
</ng-container>
